import React, { useState } from 'react'
import Table from 'react-bootstrap/Table';
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";
import { Typewriter } from 'react-simple-typewriter'
import Callback from './Callback';
import ShiftingProcess from './ShiftingProcess';
import WorkProcess from './WorkProcess';
import helpdeskdetails from "../images/Helpdesk.jpg";
import Contactform from './Contactfrom';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function Homepage() {



      const [show, setShow] = useState(false);
      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);
    
      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 3
      };
    
  return (
    <div>
                <div style={{
                backgroundImage: "url(" + "https://i.postimg.cc/zGf7BK72/home-shifting-photo-copy.jpg" + ")",
                backgroundPosition: 'start',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
              }}>
                <div className="album py-1">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-8 mt-3">
                        <button className='iba'>IBA Approved Packers and Movers</button>
                        <h1 style={{ fontSize: "3rem", color: "white" }} className="card-text mb-4"> <b>Best Home Shifting Services in Kolkata</b></h1>
        
                        <h6 style={{ color: "white" }} className="card-text mb-5"> We have 35+ years of robust experience to smoothen your home moving experience</h6>
                        <h1 className="card-text " style={{ margin: "auto 0", color: "white" }}> <b> Best Home Shifting Services in :  <span style={{ fontWeight: "bold", marginleft: '10px', color: "white" }}>
                          <Typewriter
                            loop
                            cursor
                            cursorStyle="_"
                            typeSpeed={100}
                            deleteSpeed={50}
                            delaySpeed={1000}
                            words={["New Town", "Hoogle", "Durgapur", "Bengalore", "Delhi", "Siliguri"]}
                          />
                        </span>
                        </b></h1>
                        <div className="indiastrustedwebsitedevelopment">
                          <h3 style={{ fontSize: "1rem", color: "white" }} className="card-text mb-8 mt-2"> <b>AT INDIA PACKERS MOVERS</b></h3>
                        </div>
                      </div>
                      <div className="col-md-4 mt-3">
                        <div className='packer_Rajarhatkolkata'>
                          <Contactform />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <br />
                <br />
        
        
        
              </div>
        
              <div className='grey'>
                <br />
                <div className="album py-1">
        
                  <div className="container">
                    <center><h2 style={{ color: "#05438e" }}>How does it Work?</h2></center>
                  </div>
                </div>
                <div className="album py-1">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-8 mt-3">
                        <WorkProcess />
                      </div>
                      <div className="col-md-4 mt-4">
                        <div className="card" >
                          <img src={helpdeskdetails} className="card-img-top" alt="helpdeskdetails" />
                          <div className="card-body">
                            <h5 style={{ color: "#05438e" }} className="card-title"><center>Helpful Details</center></h5>
                            <p className="card-text">Packing tips</p>
        
                          </div>
                        </div>
        
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <br />
        
              </div>
           
              <div className='homeshiftprice'>
                   <br />
              <div className="container">
                <div className='welcometext'>
                  <h1 className="card-title mb-0"><b>Check Our Affordable House Shifting Prices Below:
        
                  </b></h1>
                  <div className="col-md-10">
                    <hr style={{ color: "#1D4D93" }} />
                  </div>
                </div>
              </div>
              <div className="animat">
                <Slider {...settings}>
        
                  <div>
        
                    <div className="card mb-12">
                      <Table striped bordered hover variant="light">
                        <thead>
                          <tr>
                            <th style={{ color: "#0439b5ff" }}>Move Type/Distance	</th>
                            <th style={{ color: "#0335aaff" }}>100 - 350 km</th>
                            <th style={{ color: "#032062" }}>350 - 750 km</th>
                            <th style={{ color: "#032062" }}>750 - 1200 km</th>
                            <th style={{ color: "#032062" }}>1200 - 1700 km</th>
                            <th style={{ color: "#032062" }}>1700 - 2300 km	</th>
                            <th style={{ color: "#032062" }}>2300 - 3000 km</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1 BHK</td>
                            <td>Rs. 11,000 - 21,000</td>
                            <td>	Rs. 13,500 - 22,500</td>
                            <td>Rs. 15,500 - 25,500</td>
                            <th>Rs. 18,500 - 27,000</th>
                            <th>Rs. 21,000 - 30,000</th>
                            <th>Rs. 23,500 - 36,700</th>
        
        
                          </tr>
                          <tr>
                            <td>2 BHK</td>
                            <td>Rs. 15,000 - 25,000</td>
                            <td>Rs. 17,500 - 28,500</td>
                            <td>Rs. 20,000 - 31,000</td>
                            <th>Rs. 23,000 - 36,000</th>
                            <th>Rs. 27,000 - 40,000</th>
                            <th>Rs. 29,300 - 46,000</th>
        
                          </tr>
                          <tr>
                            <td>3 BHK</td>
                            <td >Rs. 18,000 - 30,000</td>
                            <td>Rs. 21,000 - 34,000	</td>
                            <td>Rs. 23,500 - 38,000</td>
                            <th>Rs. 27,500 - 42,000</th>
                            <th>Rs. 32,000 - 48,000</th>
                            <th>Rs. 35,000 - 55,500</th>
        
                          </tr>
        
        
        
        
                          <tr>
                            <td>4+ BHK/Villa</td>
                            <td> Rs. 22,500 - 34,500</td>
                            <td>Rs. 26,000 - 39,000	</td>
                            <td>Rs. 29,000 - 45,000	</td>
                            <th>Rs. 34,000 - 47,500</th>
                            <th>Rs. 38,000 - 55,000</th>
                            <th>Rs. 41,000 - 60,000</th>
        
        
                          </tr>
        
        
        
        
        
                        </tbody>
                      </Table>
        
                    </div>
        
                  </div>
        
                  <div>
                    
                   
                  </div>
        
               
        
        
                  
                  
                  <div>
                
                  </div>
        
        
        
        
                </Slider>
              </div>
        <br />
        <br/>
        </div>
    
    </div>
  )
}

export default Homepage